
import { useI18n } from "vue-i18n";
import { resverText, isMobile, isCanSerialize } from "@/utils/index";
import { defineComponent, ref, reactive, watch, onMounted, computed, nextTick } from "vue";
import { useRoute } from "vue-router";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import * as Cashier from "@/api/cashier";
import useClipboard from "vue-clipboard3";
import {
  Field,
  Button,
  DropdownMenu,
  DropdownItem,
  Cell,
  CellGroup,
  CountDown,
  Toast,
  Loading,
  Overlay,
  Icon,
  Popover,
  ActionSheet,
  Skeleton,
  Calendar,
  DatetimePicker,
  NumberKeyboard,
  Dialog
} from "vant";
import "@vant/touch-emulator";

import {
  InterfaceUI,
  CoinMapCountry,
  Languages,
  FormatDateZone,
  CreateOrderParams,
  FormData,
  OptionObject,
  CashPayInOrderStatus,
  ChannelObject,
  ChannelCurrencyRatesObject,
  SupportedBanksList,
  SupportedCountries
} from "./interface";
import KP_SELECT from "@/components/KP_SELECT.vue";
import KP_INPUT from "@/components/KP_INPUT.vue";
import KP_PICKER from "@/components/KP_PICKER.vue";

export default defineComponent({
  name: "payin",
  components: {
    VueQrcode,
    [Field.name]: Field,
    [Button.name]: Button,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [CountDown.name]: CountDown,
    [Toast.name]: Toast,
    [Loading.name]: Loading,
    [Overlay.name]: Overlay,
    [Icon.name]: Icon,
    [Popover.name]: Popover,
    [ActionSheet.name]: ActionSheet,
    [Skeleton.nane]: Skeleton,
    [Calendar.name]: Calendar,
    [DatetimePicker.name]: DatetimePicker,
    [NumberKeyboard.name]: NumberKeyboard,
    [Dialog.name]: Dialog,
    KP_SELECT,
    KP_INPUT,
    KP_PICKER
  },
  setup() {
    const route = useRoute();
    const { t, locale } = useI18n();
    const { lang, k, from } = route.query;

    const showSupplierSheet = ref(false);
    const showBankSheet = ref(false);
    const result = ref(false);
    const showPopover = ref(false);
    const currentLang = ref();
    const loaded = ref(false);
    const showCalendar = ref(false);

    currentLang.value = lang ?? "en";
    let data = reactive({
      dev: process.env.VUE_APP_BUILD_ENV,
      token: k,
      path: window.location.origin,
      InterfaceUI,
      Languages,
      FormData,
      minData: new Date(),
      Search: {
        supplier: "",
        bank: ""
      }
    });

    const changeLang = item => {
      locale.value = item.value;
    };

    watch(
      currentLang,
      newLang => {
        locale.value = newLang;
      },
      {
        immediate: true
      }
    );
    const getLangName = computed(() => {
      return (
        data.Languages.find(x => {
          return x.value === locale.value;
        })?.text || ""
      );
    });

    // 复制
    const { toClipboard } = useClipboard();
    const copy = async (text: string) => {
      try {
        await toClipboard(text);
        Toast({
          message: t("defray.copied"),
          overlay: false,
          duration: 800
        });
      } catch (e) {
        console.error(e);
      }
    };

    /**
     * 倒计时结束
     **/
    const isFinish = ref(false);
    const finish = () => {
      isFinish.value = true;
      if (data.FormData.orderStatus == 1) {
        getOrderInfo();
      }
    };

    /**
     * 分割时、分、秒
     **/
    const splitNumber = number => {
      let data = number.toString().split("");
      let n1 = 0,
        n2 = 0;
      if (data.length == 2) {
        n1 = data[0];
        n2 = data[1];
      } else if (data.length == 1) {
        n2 = data[0];
      }
      return [n1, n2];
    };

    /**
     * 获取通道列表
     */
    const __CashChannelList = ref<Array<ChannelObject>>([]);
    const getChannelList = async () => {
      const loadingToast = Toast({
        message: "",
        type: "loading",
        duration: 0
      });
      const res = await Cashier.CashChannelList();
      loadingToast?.close();
      if (res?.code == 200) {
        let list: [ChannelObject] = res?.data || [];
        __CashChannelList.value = list;
        await getOrderInfo();
        GetChannelListByCoin();
        // 预下单
        if (data.FormData.orderStatus == 0) {
          getCashierTopUpRequiredFields();
        }
      } else {
        Toast({
          message: res?.message || t("error"),
          overlay: false,
          duration: 2000
        });
      }
    };

    /**
     * 通过币种筛选出支持的通道列表
     */
    const CashChannelList = ref<Array<ChannelObject>>([]);
    const GetChannelListByCoin = () => {
      let list =
        __CashChannelList.value.filter((x: ChannelObject) => {
          return x.cashChannelCurrencyRateSetting.find((channel: ChannelCurrencyRatesObject) => {
            return channel?.currency === data.FormData.currency && channel?.flowDirection === 0;
          });
        }) || [];
      CashChannelList.value = list;
      if (list.length) {
        data.FormData.channelCode = list[0]?.code;
      }
    };

    /**
     * 通过通道获取对应的支付方式
     */
    const PaymentTypeList = computed(() => {
      if (!data.FormData.channelCode) return;
      let cashChannelCurrencyRateSetting =
        CashChannelList.value.find((x: ChannelObject) => {
          return x.code == data.FormData.channelCode;
        })?.cashChannelCurrencyRateSetting || [];

      let __data =
        cashChannelCurrencyRateSetting.filter(x => {
          return (
            x.currency == data.FormData.currency && x.flowDirection == 0 && x.supportedChannelType
          );
        }) || [];

      let list: Array<ChannelCurrencyRatesObject> = [];
      let temp = {};
      __data.map(x => {
        if (!temp[x.supportedChannelType]) {
          temp[x.supportedChannelType] = x.supportedChannelType;
          list.push(x);
        }
      });

      if (list.length > 0) {
        let item = list[0] || {};
        data.FormData.paymentType = item?.supportedChannelType;
        data.FormData.transactionFee = item?.transactionFee || 0;
      }
      // 处理没有任何渠道类型时，费率问题
      else {
        __data =
          cashChannelCurrencyRateSetting.filter(x => {
            return x.currency == data.FormData.currency && x.flowDirection == 0;
          }) || [];
        if (__data.length) {
          data.FormData.transactionFee = __data[0]?.transactionFee || 0;
        }
      }
      return list;
    });

    /**
     * 通过编码查找对应的名称
     * @param code 编码Code
     * @param list 列表数据
     */
    const getNameByCode = (code: string, list: Array<OptionObject>) => {
      return (
        list.find((x: OptionObject) => {
          return x.value == code;
        })?.key || ""
      );
    };

    // 运营商列表
    const SupplierList = computed(() => {
      let list =
        __CashChannelList.value.find((x: ChannelObject) => {
          return x.code == data.FormData.channelCode;
        })?.cashChannelCurrencyRateSetting || [];

      let temp =
        list.filter(x => {
          return (
            x.currency == data.FormData.currency && x.flowDirection == 0 && x.supportedMobileType
          );
        }) || [];

      if (temp.length > 1) {
        return (
          temp.map(x => {
            return {
              name: x.supportedMobileType,
              value: x.supportedMobileType
            };
          }) || []
        );
      } else if (temp.length == 1) {
        let __supportedMobileType = temp[0].supportedMobileType;
        if (Array.isArray(__supportedMobileType)) {
          return (
            __supportedMobileType.map(x => {
              return {
                name: x,
                value: x
              };
            }) || []
          );
        } else {
          return {
            name: __supportedMobileType,
            value: __supportedMobileType
          };
        }
      }
    });

    let extendFieleds = [];
    const onSelectChange = val => {
      if (val.fieldName.includes("bank")) {
        data.FormData.bankName =
          val.list.find(x => {
            return x.key == val.value.key;
          })?.value || "";
        return;
      }

      const childs =
        val.list.find(x => {
          return x.key == val.value.key;
        })?.childs || [];

      if (!childs.length) {
        return;
      }

      extendFieleds.map(x => {
        // @ts-ignore
        data.FormData[x] = "";
        delete data.FormData[x];
        dynamicsFiledList.value.splice(
          // @ts-ignore
          dynamicsFiledList.value.findIndex(f => f?.key == val.value.key),
          1
        );
      });

      nextTick(() => {
        extendFieleds = [];
        childs.map(x => {
          data.FormData[x?.field_name] = "";
          // @ts-ignore
          dynamicsFiledList.value.push(x);
        });
        extendFieleds = childs.map(x => {
          return x.field_name;
        });
      });
    };

    // 银行列表
    const BankList = computed(() => {
      let list =
        __CashChannelList.value.find((x: ChannelObject) => {
          return x.code == data.FormData.channelCode;
        })?.cashChannelCurrencyRateSetting || [];

      let supportBanks =
        list?.find(x => {
          return (
            x.currency == data.FormData.currency &&
            x.flowDirection == 0 &&
            (["DIRECT", "BANK", "SPEI"].includes(x.supportedChannelType) ||
              (x.supportedChannelType == "BANKTRANSFER" && data.FormData.channelCode == "DukPay"))
          );
        })?.supportBanks || [];

      // 输入筛选过滤
      if (data.Search.bank) {
        supportBanks = supportBanks.filter(x => {
          return (
            x.bankCode.includes(data.Search.bank) ||
            x.bankName.toLocaleLowerCase().includes(data.Search.bank.toLocaleLowerCase())
          );
        });
      }

      return supportBanks.map((x: SupportedBanksList) => {
        return {
          name: x.bankName,
          value: x.bankCode
        };
      });
    });
    const onSelectBank = val => {
      showBankSheet.value = false;
      data.FormData.bankCode = val.value;
    };

    // 国家列表
    const CountryList = computed(() => {
      let list =
        __CashChannelList.value.find((x: ChannelObject) => {
          return x.code == data.FormData.currency;
        })?.cashChannelCurrencyRateSetting || [];

      let temp =
        list.find(x => {
          return (
            x.currency == data.FormData.currency &&
            x.flowDirection == 0 &&
            ["MOMO", "OVO"].includes(x.supportedChannelType)
          );
        })?.supportedCountries || [];

      return temp.map((x: SupportedCountries) => {
        return {
          name: `${x.name} (${x.code})`,
          value: x.code
        };
      });
    });

    /**
     * 获取订单信息
     */
    const getOrderInfo = async () => {
      const loadingToast = Toast({
        message: "",
        type: "loading",
        duration: 0
      });
      const res = await Cashier.GetPayInOrderInfo();
      loadingToast?.close();
      if (res?.code == 200) {
        data.FormData = Object.assign(data.FormData, res?.data || {});
        if (data.FormData.orderStatus == 1) {
          setTimeout(() => {
            getStatus();
          }, 3000);
        }
      } else {
        Toast({
          message: res?.message || t("error"),
          overlay: false,
          duration: 2000
        });
      }
    };

    // 轮询获取状态
    const getStatus = async () => {
      const res = await Cashier.GetPayInOrderInfo();
      if (res?.code == 200) {
        data.FormData = Object.assign(data.FormData, res?.data || {});
        switch (data.FormData.orderStatus) {
          // Pending
          case 1:
            setTimeout(() => {
              getStatus();
            }, 5000);
            break;
          // Success
          case 2:
            setTimeout(() => {
              paymentUrl(data.FormData.redirectUrl, "SUCCESS");
            }, 1000);
            break;
          // Fail
          case 3:
            paymentUrl(data.FormData.cancelUrl, "FAIL");
            break;
          // Cancel
          case 4:
            paymentUrl(data.FormData.cancelUrl, "CANCEL");
            break;
        }
      } else {
        setTimeout(() => {
          getStatus();
        }, 5000);
      }
    };

    /**
     * 付款路由操作行为
     **/
    const paymentUrl = (url, type) => {
      if (from == "app") {
        const status = {
          SUCCESS: "CASHIER-TOPUP-SUCCESS",
          FAIL: "CASHIER-TOPUP-FAIL",
          CANCEL: "CASHIER-TOPUP-CANCEL"
        };
        window["BacktrackToApp"]?.postMessage(
          JSON.stringify({
            key: status[type],
            data: null
          })
        );
        return;
      }
      showIframeUrl.value = false;
      url && (window.location.href = url);
    };

    // 日历控件回调
    const onDateTimePickerHandler = val => {
      const year = new Date(val).getFullYear().toString();
      let month = (new Date(val).getMonth() + 1).toString();
      if (month.length < 2) {
        month = `0${month}`;
      }
      data.FormData.expiryDate = month + "/" + year.substring(year.length - 2);
      showCalendar.value = false;
    };
    const onConfirmDate = date => {
      // data.FormData.expiryDate = `${date.getMonth() + 1}/${date.getDate()}`;
      showCalendar.value = false;
    };

    /**
     * 上一步、下一步
     */
    const step = ref(1);
    const steps = ref(1);
    const nextStep = (val: boolean) => {
      if (val) {
        if (step.value == steps.value) {
          CreateTopUpOrder();
        } else {
          step.value = step.value + 1;
        }
      } else {
        step.value = step.value - 1;
      }
    };

    // 下一步按钮禁用逻辑
    const isDisableConfirm = computed(() => {
      let result = false;
      dynamicsFiledList.value.map(x => {
        // @ts-ignore
        if (!data.FormData[x?.field_name]) {
          result = true;
        }
      });
      return result;
    });

    /**
     * 创建第三方支付订单
     */
    const LinkedPayForm = ref();
    const iframeUrl = ref("");
    const CreateTopUpOrder = async () => {
      if (isDisableConfirm.value) return;
      let param: any = {
        device: isMobile() ? "mobile" : "pc"
      };
      if (data.FormData.bankName) {
        param.bank_name = data.FormData.bankName;
      }
      dynamicsFiledList.value.map(x => {
        // @ts-ignore
        const value = data.FormData[x?.field_name].trim();
        // @ts-ignore
        param[x?.field_name] = `${x?.expand ? x?.expand : ""}${value}`;
      });
      const loadingToast = Toast({
        message: "",
        type: "loading",
        overlay: true,
        duration: 0
      });
      const res = await Cashier.CreatePayIn(param);
      if (res?.code == 200) {
        data.FormData.extend = res?.data || {};
        data.FormData.thirdPlatformAmount = res?.data.thirdPlatformAmount;
        data.FormData.responseDescription = res?.data.responseDescription;
        const { checkoutUrl, responseCode, responseDescription } = res?.data;
        if (checkoutUrl) {
          // 表单提交
          if (data.FormData.channelCode == "LinkedPay") {
            await Cashier.GetFiatOrderLinkUsed();
            setTimeout(() => {
              showIframeUrl.value = true;
              LinkedPayForm.value.submit();
              setTimeout(() => {
                getOrderInfo();
              }, 200);
              loadingToast.close();
            }, 200);
          }
          // 跳转
          else {
            loadingToast.close();
            showIframeUrl.value = false;
            if (data.FormData.channelCode == "DukPay") {
              window.open(checkoutUrl, "_blank");
            } else {
              iframeUrl.value = checkoutUrl;
            }
            setTimeout(() => {
              getOrderInfo();
            }, 100);
          }

          RedirectURL();
        } else {
          loadingToast.close();
          if (responseCode?.toLowerCase() == "failed") {
            Toast({
              message: responseDescription,
              overlay: false,
              duration: 5000
            });
          } else {
            if (
              ["AlchemyPay"].includes(data.FormData.channelCode) &&
              ["QRIS", "OVO", "DIRECT"].includes(data.FormData.paymentType)
            ) {
              result.value = true;
            } else {
              getOrderInfo();
            }
          }
        }
      } else {
        loadingToast.close();
        Toast({
          message: res?.message || t("cashier.error"),
          overlay: false,
          duration: 5000
        });
      }
    };

    // 监听第三方支付平台完成了操作，监听执行跳转的逻辑
    // 跳出iframe回到下游业务系统指定页面
    const RedirectURL = () => {
      setTimeout(() => {
        if (showIframeUrl.value) {
          let timeStamp = 0;
          const myIframe = document.getElementById("myIframe") || document.createElement("iframe");
          myIframe.addEventListener("load", function(e) {
            if (timeStamp == 0) {
              timeStamp = e.timeStamp;
              return;
            }

            if (e.timeStamp > timeStamp && timeStamp !== 0) {
              // console.log(myIframe?.src, data.FormData.redirectUrl);
              // @ts-ignore
              if (data.FormData.redirectUrl && myIframe?.src == data.FormData.redirectUrl) {
                window.location.href = data.FormData.redirectUrl;
              }
              // @ts-ignore
              if (myIframe?.src == window.location.href) {
                if (data.FormData.redirectUrl) {
                  window.location.href = data.FormData.redirectUrl;
                } else {
                  if ([2, 3, 4].includes(data.FormData.orderStatus)) {
                    showIframeUrl.value = false;
                  }
                }
              }
            }
          });
        }
      }, 2000);
    };

    const showIframeUrl = ref(false);
    const toPay = async () => {
      if (data.FormData.channelCode == "LinkedPay") {
        const res = await Cashier.GetFiatOrderLinkUsed();
        if (res?.code == 200) {
          if (!res?.data) {
            showIframeUrl.value = true;
            LinkedPayForm.value.submit();
          } else {
            LinkedPayForm.value.remove();
            Dialog({
              title: t("tips"),
              message: t("used"),
              confirmButtonText: t("yes")
            });
          }
        }
      } else {
        showIframeUrl.value = false;
        if (data.FormData.channelCode == "DukPay") {
          window.open(data.FormData.checkoutUrl, "_blank");
        } else {
          iframeUrl.value = data.FormData.checkoutUrl;
        }
      }
      RedirectURL();
    };

    const dynamicsFiledList = ref([]);
    const getCashierTopUpRequiredFields = async () => {
      const loadingToast = Toast({
        message: "",
        type: "loading",
        overlay: true,
        duration: 0
      });
      const res = await Cashier.CashierTopUpRequiredFields();
      loadingToast.close();
      if (res?.code == 200) {
        const temp = res?.data || [];
        const list = temp.filter(
          x => !["redirect_url", "user_ip", "device"].includes(x.field_name)
        );
        // Pre-sort "Supplier" and "BankCode" field
        list.unshift(
          ...list.splice(
            list.findIndex(item => ["bank_code", "supplier"].includes(item.field_name)),
            1
          )
        );
        dynamicsFiledList.value = list;
        dynamicsFiledList.value.map(x => {
          // @ts-ignore
          data.FormData[x?.field_name] = "";
        });
        steps.value = dynamicsFiledList.value.length ? 2 : 1;
      }
    };

    onMounted(() => {
      if (k == undefined || !k) {
        Toast({
          message: t("error"),
          overlay: false,
          duration: 5000
        });
        return;
      }
      getChannelList();
    });

    return {
      locale,
      resverText,
      from,
      isCanSerialize,

      data,
      currentLang,
      showPopover,
      showSupplierSheet,
      showBankSheet,
      showCalendar,
      onConfirmDate,
      changeLang,
      getLangName,
      FormatDateZone,
      copy,
      loaded,
      isFinish,
      finish,

      splitNumber,
      paymentUrl,
      isDisableConfirm,
      step,
      steps,
      nextStep,

      showIframeUrl,
      iframeUrl,
      toPay,
      result,

      CashPayInOrderStatus,
      LinkedPayForm,
      CashChannelList,
      PaymentTypeList,
      getNameByCode,
      onDateTimePickerHandler,

      SupplierList,
      onSelectChange,
      BankList,
      onSelectBank,

      dynamicsFiledList
    };
  }
});
